import i18next from "../i18n/config";

const NEXT_DAY_REMINDER_ID = "daily-challenge-next-day-reminder";

interface NativeNotificationBridge {
  schedule(id: string, title: string, body: string, atMillis: number): void;
}

function getNativeBridge(): NativeNotificationBridge | null {
  const w = window as any;

  if (w.webkit?.messageHandlers?.["schedule-local-notification"]) {
    return {
      schedule: (id, title, body, atMillis) => {
        w.webkit.messageHandlers["schedule-local-notification"].postMessage(
          JSON.stringify({ id, title, body, at: atMillis }),
        );
      },
    };
  }

  if (w.AndroidNotifications) {
    return {
      schedule: (id, title, body, atMillis) => {
        w.AndroidNotifications.scheduleLocalNotification(id, title, body, String(atMillis));
      },
    };
  }

  return null;
}

export class NotificationService {
  private static instance: NotificationService;

  static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  // Call when the player completes today's daily challenge kill target. Schedules a
  // single noon reminder for the next day, to keep the streak alive.
  scheduleNextDayReminder(): void {
    const bridge = getNativeBridge();
    if (!bridge) return;

    const tomorrowNoon = new Date();
    tomorrowNoon.setDate(tomorrowNoon.getDate() + 1);
    tomorrowNoon.setHours(12, 0, 0, 0);

    bridge.schedule(
      NEXT_DAY_REMINDER_ID,
      i18next.t("notifications:dailyChallengeTitle"),
      i18next.t("notifications:dailyChallengeReminderBody"),
      tomorrowNoon.getTime(),
    );
  }
}
